import React from 'react';
import { obtenerlistadepta } from '../../Redux/DepartamentosDucks'
import { obtenerhistorialempleadosdepta } from '../../Redux/ReportesDucks'
import { useDispatch, useSelector } from 'react-redux'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { Button, Grid, IconButton } from '@mui/material';
import AutorenewIcon from '@mui/icons-material/Autorenew';
const BotonBuscarxDepta = () => {

  const dispatch = useDispatch()
  const depta = useSelector(store => store.depta.deptadata)
  const empresa = useSelector(store => store.depta.empresa)

  const empT = sessionStorage.getItem('em')
  const depT = sessionStorage.getItem('dep')

  const [bd, setBd] = React.useState(empT);
  const [dep, setDep] = React.useState(parseInt(depT));

  const handleChange = (event) => {
    setBd(event.target.value)
    sessionStorage.setItem('em', (event.target.value))

  }

  const obtenerdepta = (e) => {
    dispatch(obtenerlistadepta(bd))
  }

  const handleChange2 = async (event) => {
    setDep(event.target.value)
    sessionStorage.setItem('dep', (event.target.value))
  };

  const obtenerhistorialempleadosxdepta = (e) => {
    if (dep === '') {
      alert('Selecciona un departamento')
    } else {
      dispatch(obtenerhistorialempleadosdepta(bd, dep))
    }
  }

  React.useEffect(() => {
    const obtenerInfodep = async () => {
      dispatch(obtenerlistadepta(bd))
    }
    obtenerInfodep()

  }, [bd])


  return (
    <Grid container direction='row' spacing={1} alignContent='center' >
      <Grid item>
        <FormControl size='small' sx={{ minWidth: 250 }} md={{ minWidth: 300 }}>
          <InputLabel id="demo-simple-select-autowidth-label">Empresa</InputLabel>
          {empresa.length === 0 ? (
            null) : <>
            <Select
              labelId="demo-select-small"
              id="demo-select-small"
              value={bd}
              label="Empresa"
              displayEmpty
              inputProps={{ 'aria-label': 'Without label' }}
              onChange={handleChange}
            >
              {
                empresa.map((rowempresa, index) => (
                  <MenuItem key={index} value={rowempresa.GUIDEmpresa}>{rowempresa.RutaEmpresa}</MenuItem>
                ))}
            </Select> </>

          }

        </FormControl>
      </Grid >

      <Grid item>
        <FormControl size='small' sx={{ minWidth: 250 }} md={{ minWidth: 300 }}>
          <InputLabel id="demo-simple-select-autowidth-label">Departamento</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            defaultValue=''
            value={dep}
            label="Buscar departamento"
            displayEmpty
            inputProps={{ 'aria-label': 'Without label' }}
            onChange={handleChange2}
          >
            <MenuItem value=''>
              <em></em>
            </MenuItem>
            {
              depta.map((dept, index) => (
                <MenuItem key={index} value={dept.iddepartamento}>{dept.descripcion}</MenuItem>
              ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item>

        <IconButton variant='contained' onClick={(event) => obtenerdepta(bd)}><AutorenewIcon /></IconButton>
      </Grid>
      <Grid item>

        <Button variant='contained' color="success" onClick={(event) => obtenerhistorialempleadosxdepta(event)}>Buscar</Button>
      </Grid>
    </Grid>

  )
}



export default BotonBuscarxDepta